const lbaSubNav = angular.module('app.lbaSubNav', []);

lbaSubNav.component('lbaSubNav', {
  bindings: {},
  controllerAs: 'vm',
  controller: ['$location', 'subNavService', controller],
  template: require('./lbaSubNav.html')
});

function controller($location, subNavService) {
  let vm = this;
  vm.subNav = subNavService;
  vm.showTab = showTab;

  function showTab(link) {
    $location.path(link);
  }

}

export default lbaSubNav;


// WEBPACK FOOTER //
// ./src/components/lbaSubNav/lbaSubNav.js